<template>
  <div>
    <div id="urlInfo" @click="determine"></div>
  </div>
</template>

<script>

export default {
  data() {
    return {};
  },
  mounted() {
    this.determine();
  },
  methods: {
    determine() {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
      var isIOS = u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1; //ios终端
      if (isAndroid) {
          window.JSView.callback();
      } else if (isIOS) {
        var dict = {
          name: "LiBaoQin",
          gender: "Boy",
        };
        window.webkit.messageHandlers.back.postMessage(dict);
      }
    },
  },
};
</script>

<style  scoped>
.image {
  text-align: center;
  margin-top: 100px;
}
p {
  text-align: center;
  margin-top: 20px;
}
.sures {
  text-align: center;
  margin-top: 80px;
}
.el-button {
  width: 150px;
  height: 44px;
  background: #ff615c;
  color: #fff;
  border: none;
}
.userInfo{
  height: 100vh;
  width: 100px;
  background: red;
}
</style>
